import React, { useEffect, useState } from 'react';
import PackageInfoCard from '../Components/PackageInfoCard';
import { useLocation, useNavigate } from 'react-router-dom';
import { Grid, Typography, Select, MenuItem, Paper } from '@mui/material';
import { KeyboardArrowRight, KeyboardArrowLeft, Edit, DeleteForever } from '@mui/icons-material';
import PackageDetailsCard from '../Components/PackageDetailsCard';
import Skeleton from '@mui/material/Skeleton';
import ReactMarkdown from 'react-markdown';
import ReactPlayer from 'react-player';
import videoImagesGoesHere from '../assets/videoImagesGoesHere.jpg';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import Tooltip from '@mui/material/Tooltip';
import MuiAlert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import { Card, Box } from '@mui/material';
import { useTheme } from '@mui/system';
import { getPermissionForPackage, getComponentDetails } from '../utils/api';
import { getUpdatedPermission } from '../utils/utility';
import { ImageGallery } from '../Components/ImageGallery';
import CustomSnackBar from '../Components/CustomSnackBar';
import ConfirmDialog from '../Components/ConfirmDialog';
import VideoModal from '../Components/VideoModal';
import MovingDot from '../Components/MovingDot';
import ActionMenu from '../Components/IntegratedActionMenu';
import { dialogTitles, dialogMap } from '../utils/constants';
import { carouselDivStyle, carouselImageStyle, carouselWrapperStyle, largeIconStyle, arrowWrapperStyle } from '../Styles/PackageInfoStyles';
import Loader from '../Components/Loader';
import { useGlobal } from '../Context/globalContext';


const disableRemoveActions = ['disableDev', 'disableProd', 'removeDev', 'removeProd'];



const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const sideScroll = (
  element,
  speed,
  distance,
  step
) => {
  let scrollAmount = 0;
  const slideTimer = setInterval(() => {
    element.scrollLeft += step;
    scrollAmount += Math.abs(step);
    if (scrollAmount >= distance) {
      clearInterval(slideTimer);
    }
  }, speed);
};


const PackageInfo = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { userData, bucketURLS = {} } = useGlobal();
  const { hd_id, publishDate } = location.state || {};
  const [templateName, setTemplateName] = useState('');
  const [componentName, setComponentName] = useState('');
  const [packageInfo, setPackageInfo] = useState(null);
  const [carouselItems, setCaraouselItems] = useState([]);
  const [readMe, setReadMe] = useState('')
  const [videoUrl, setVideoUrl] = useState('');
  const contentWrapper = React.useRef(null);
  const [loading, setLoading] = useState(true);
  const [templatesAvailable, setTemplatesAvailable] = useState([]);
  const [deleteSuccess, setDeleteSuccess] = useState(false);
  const [downloadUrl, setDownloadUrl] = useState('');
  const [permission, setPermission] = useState([]);
  const [updatedPermission, setUpdatedPermission] = useState([])
  const [owners, setOwners] = useState([])
  const [openImageGallery, setOpenImageGallery] = useState(false);
  const [error, setError] = useState('');
  const [openSnackBar, setOpenSnackBar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [showLoader, setShowLoader] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [currentDialog, setCurrentDialog] = useState(null);
  const [openVideoModal, setOpenVideoModal] = useState(false);




  const openDialog = (dialogType) => {
    setCurrentDialog(dialogType);
    setDialogOpen(true);
  };

  const theme = useTheme();


  useEffect(() => {
    window.scrollTo(0, 0);
    const searchParams = new URLSearchParams(location.search);
    const templateNameFromPath = searchParams.get('templateName');
    const componentNameFromPath = searchParams.get('componentName');

    if (location?.state?.templateName) {
      setTemplateName(location.state.templateName)
    } else {
      setTemplateName(templateNameFromPath)
    }
    if (location?.state?.componentName) {
      setComponentName(location.state.componentName)
    } else {
      setComponentName(componentNameFromPath)
    }

  }, [])

  useEffect(() => {
    if (bucketURLS.portal) {
      setDownloadUrl(bucketURLS.portal)
    }

  }, [bucketURLS])

  useEffect(() => {
    if (componentName) {
      getPermissionForPackage(componentName).then(data => {
        setPermission(data);
        const ownersArray = data
          .filter(item => item.permission === 'owner')
          .map(item => item.userID);

        setOwners(ownersArray)
      }).catch(error => {
        console.error(error);
      });
    }


  }, [componentName])

  useEffect(() => {
    const fetchPermissions = async () => {
      if (permission && permission.length) {
        const updatedPermission = await getUpdatedPermission(permission);
        setUpdatedPermission(updatedPermission);

      }
    };

    fetchPermissions();
  }, [permission]);



  const fetchReadme = async () => {
    try {
      const response = await fetch(`/c/${componentName}/README.md`, {
        credentials: "include"
      });
      if (response.ok) {
        const readMeData = await response.text();
        setReadMe(readMeData)
        handleUpdate(readMeData)


      } else {
        setLoading(false)
        console.error('Failed to fetch ReadMe:', response.status, response.statusText);
      }
    } catch (error) {
      setLoading(false)
      console.error('Error fetching ReadMe:', error);
    }
  };
  const handleUpdate = (readMeText) => {
    const params = new URLSearchParams();
    params.append('componentName', componentName);
    params.append('existingTemplateName', templateName);
    const url = `/nodeapi/portal/update-component?${params.toString()}`;
    const payload = {
      info: {
        description: readMeText,
      }
    };
    const headers = {
      "Content-Type": "application/json",
    };

    const requestOptions = {
      method: "POST",
      headers: headers,
      body: JSON.stringify(payload),
      credentials: "include",
    };

    fetch(url, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result && result.success && result.success === 1) {
          fetchPackageInfo()
          setLoading(false)
        } else {
          setLoading(false)
        }


      })
      .catch((error) => {
        console.error("Error:", error);
        setLoading(false)

      });
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenSnackBar(false);
  };

  const fetchPackageInfo = async () => {
    try {
      const result = await getComponentDetails(componentName, templateName);

      if (result?.data) {
        const portalData = result.data?.details?.portal_data;
        let carouselData = [];

        setPackageInfo(result.data);

        if (portalData?.videoUrl) {
          setVideoUrl(portalData.videoUrl);
          carouselData.push(portalData.videoUrl);
        }

        if (portalData?.images) {
          portalData.images.forEach((item) => {
            if (typeof item === "string") {
              carouselData.push(item);
            }
          });
        }

        setCaraouselItems(carouselData);

        const from = location?.state?.from;
        if (!(portalData && portalData.description) && from === "dashboard") {
          fetchReadme();
        } else {
          setLoading(false);
        }
      }
    } catch (error) {
      console.error("Error fetching packageData:", error);
    }
  };

  const fetchTemplatesAvailable = async () => {
    try {
      const params = new URLSearchParams();
      params.append('componentName', componentName);
      const response = await fetch(`/nodeapi/portal/component-templates?${params.toString()}`, {
        method: 'GET',
        headers: {
          accept: 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`Error! status: ${response.status}`);
      }

      const data = await response.json();

      if (data && data.length) {
        setTemplatesAvailable(data);
        if (deleteSuccess) {
          setTemplateName(data[0]);
          fetchPackageInfo();
          setDeleteSuccess(false);
        }
      }
      return data;
    } catch (err) {
      console.log(err);
    }
  };

  const handleConfirm = (checkBoxes, mcpStatus) => {
    if (disableRemoveActions.includes(currentDialog)) {
      disableRemoveHandlerForIntegrated(currentDialog);
    } else {
      switch (currentDialog) {
        case 'deleteTemplate':
          deleteTemplate();
          break;
        case 'deletePackage':
          deletePackage();
          break;
        case 'moveIntegratedToProd':
          movePackageHandler('moveIntegratedToProd', checkBoxes, mcpStatus);
          break;
        default:
          console.warn('Unhandled dialog type:', currentDialog);
      }
    }
    setDialogOpen(false);
  };


  const disableRemoveHandlerForIntegrated = async (currentDialog) => {
    // console.log('currentDialog', currentDialog)
    setShowLoader(true);
    const { type, destination } = dialogMap[currentDialog] || {};

    const params = new URLSearchParams();
    params.append('componentName', componentName);

    try {
      const response = await fetch(`/nodeapi/portal/disable-remove-integrated?${params.toString()}&type=${type}&destination=${destination}`, {
        method: 'get',
        headers: {
          accept: 'application/json',
        },
        credentials: "include"
      });

      if (response.ok) {
        setShowLoader(false);
        setOpenSnackBar(true);
        setSnackbarMessage(`${type} on ${destination} for ${componentName} Successfull!`);
        setError(false);
        // if(type === 'remove'){
        //   navigate('/', { state: { selectedCategory: 'all-packages' } })

        // }else{
        //   fetchPackageInfo();
        // }
      } else {
        setShowLoader(false);
        setOpenSnackBar(true);
        setError(`Error occurred for ${type} on ${destination} for ${componentName}!`);

      }
    } catch (err) {
      console.log(err);
      setShowLoader(false);
      setOpenSnackBar(true);
      setError(`Error occurred for ${type} on ${destination} for ${componentName}!`);
    }



  }


  const deleteTemplate = async () => {
    const params = new URLSearchParams();
    params.append('componentName', componentName);
    params.append('templateName', templateName);
    try {
      const response = await fetch(`/nodeapi/portal/delete-template?${params.toString()}`, {
        method: 'DELETE',
        headers: {
          accept: 'application/json',
        },
        credentials: "include"
      });

      if (response.ok) {
        setDialogOpen(false);
        setDeleteSuccess(true);
        fetchTemplatesAvailable()

      } else {
        throw new Error(`Error! status: ${response.status}`);
      }
    } catch (err) {
      console.log(err)
    }

  }


  const deletePackage = async () => {
    const params = new URLSearchParams();
    params.append('componentName', componentName);
    try {
      const response = await fetch(`/nodeapi/portal/delete-package?${params.toString()}`, {
        method: 'DELETE',
        headers: {
          accept: 'application/json',
        },
        credentials: "include"
      });

      if (response.ok) {
        setDialogOpen(false);
        navigate('/my-packages', { state: { selectedCategory: 'my-packages' } })

      } else {
        throw new Error(`Error! status: ${response.status}`);
      }
    } catch (err) {
      console.log(err)
    }

  }

  const movePackageHandler = async (type, checkBoxes = null, mcpStatus = false) => {
    setShowLoader(true);
    const version = packageInfo?.review?.component_version;

    let url = "";
    let requestOptions = {
      method: "GET",
      credentials: "include",
    };

    if (type === 'moveIntegratedToProd') {
      url = `/nodeapi/portal/move-integrated-to-prod?componentName=${encodeURIComponent(componentName)}`;
      requestOptions = {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ position: checkBoxes, mcpStatus }),
      };
    }

    try {
      const response = await fetch(url, requestOptions);
      const result = await response.json();

      if (result && result.success === 1) {
        fetchPackageInfo();
        setShowLoader(false);
        setOpenSnackBar(true);
        setSnackbarMessage("Package moved to production Successfully");
        setError(false);
      } else {
        setShowLoader(false);
        setOpenSnackBar(true);
        setError("Error in moving package to production");
      }
    } catch (error) {
      console.error("Error:", error);
      setShowLoader(false);
      setOpenSnackBar(true);
      setError("Error in moving package to development");
    }
  };


  useEffect(() => {
    if (templateName) {
      fetchPackageInfo(templateName);
      fetchTemplatesAvailable();

    }
  }, [componentName, templateName, deleteSuccess])

  const handleItemClick = (index) => {
    if (contentWrapper && contentWrapper.current) {
      const itemWidth = contentWrapper.current.offsetWidth + 20; // Assuming each item has a margin-right of 20px
      const scrollPosition = itemWidth * index;
      // contentWrapper.current.scrollLeft = scrollPosition;
      contentWrapper.current.scrollTo({
        left: scrollPosition,
        behavior: 'smooth',
      });
    }
  };


  return (<div className='packageInfoPage'>
    <Grid container spacing={2}>
      <ConfirmDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        onConfirm={handleConfirm}
        showIntegratedCheckBoxes={currentDialog === 'moveIntegratedToProd'}
        title={dialogTitles[currentDialog] || ''}
        confirmText="Confirm"
        cancelText="Cancel"
        />
      <VideoModal
        open={openVideoModal}
        onClose={() => setOpenVideoModal(false)}
        videoUrl={videoUrl}
      />

      <ImageGallery setOpenImageGallery={(value) => {
        setOpenImageGallery(value)
      }}
        downloadUrl={downloadUrl}
        openImageGallery={openImageGallery} carouselItems={carouselItems} videoUrl={videoUrl} />
      {packageInfo?.details?.info?.underReview && process.env.REACT_APP_STAGE === 'production' && (owners.includes(userData?.user?.email) || userData?.is_staff) && (
        <Box sx={(theme) => ({
          margin: '10px 10px 10px auto',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-end',
          color: theme.palette.text.secondary,
          fontWeight: 600
        })}>

          <Typography sx={{
            padding: "5px 10px",
            borderRadius: "25px",
            background: "#ffffff",
            margin: "10px 0",
            display: "inline-block",
            fontWeight: 500,
            color: (theme) => theme.palette.primary.main,
            border: (theme) => `1px solid ${theme.palette.primary.main}`,
          }}>{packageInfo?.details?.componentName}@{packageInfo?.details?.info?.underReview} Under Review</Typography>
          <MovingDot />
        </Box>


      )}


      <Grid item xs={12}>
        <Box sx={{
          display: 'flex', justifyContent: 'flex-end', padding: '10px',
          [theme.breakpoints.down('sm')]: {
            justifyContent: 'flex-start'
          }
        }}>
          {
            templateName && templatesAvailable.length && templatesAvailable.length > 1 ? <Select
              id="demo-simple-select"
              value={templateName} variant="outlined"
              name="templateName"
              onChange={(e) => {
                setPackageInfo(null);
                setTemplateName(e.target.value)

              }}
              sx={{
                width: '300px', marginRight: '10px', borderRadius: '25px',
                '& .MuiInputBase-input': {
                  padding: '5px 10px'
                }
              }}
            >
              {
                templatesAvailable && templatesAvailable.length && templatesAvailable.map(item => {
                  return <MenuItem value={item}>{item}</MenuItem>

                })
              }
            </Select> : ''
          }
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'right' }}>
            {
              (templatesAvailable.length > 1 || templatesAvailable.length === 1 && packageInfo?.details?.componentName !== packageInfo?.details?.templateName && packageInfo?.details?.publishDate) && (owners.includes(userData?.user?.email) || userData?.is_staff) && !loading ?
                <Tooltip title="Create New Template">
                  <Paper style={{ marginRight: '10px', display: 'flex' }}>
                    <AddIcon style={{ cursor: 'pointer', color: '#f05f40', padding: '5px' }}
                      onClick={() => {
                        navigate(`/store-listing/${packageInfo?.details?.componentName.replace('/', '-')}`, { state: { hd_id, publishDate, componentName, templateName: '', permission: updatedPermission } });
                      }}
                    />
                  </Paper>
                </Tooltip> : null
            }
            {
              userData?.user?.email?.endsWith('@hyperdart.com') && componentName && !loading && process.env.REACT_APP_STAGE === 'development' ? (
                <Tooltip title="Approval Page">
                  <Paper style={{ marginRight: '10px', display: 'flex' }}>
                    <FactCheckIcon 
                      style={{ cursor: 'pointer', color: '#f05f40', padding: '5px' }} 
                      onClick={() => {
                        navigate(`/approval?componentName=${encodeURIComponent(componentName)}`, { 
                          state: { 
                            componentName: componentName, 
                            item: packageInfo?.details,
                            downloadUrl: downloadUrl 
                          } 
                        });
                      }} 
                    />
                  </Paper>
                </Tooltip>
              ) : null
            }
            <Box sx={{ display: 'flex' }}>
              {
                (owners.includes(userData?.user?.email) || userData?.is_staff) && packageInfo?.details?.componentName && !loading ? <div
                  onClick={() => {
                    navigate(`/store-listing/${packageInfo?.details?.componentName.replace('/', '-')}`, { state: { hd_id, publishDate, packageInfo, componentName, templateName: templateName, permission: updatedPermission } });
                  }}
                  style={{ alignItems: 'center', cursor: 'pointer', display: 'flex' }}>
                  <Tooltip title="Edit" >
                    <Paper style={{ marginRight: '10px', display: 'flex' }}> <Edit
                      style={{ color: '#f05f40', padding: '5px' }}
                    /></Paper>
                  </Tooltip>
                </div> : null
              }
              {
                showLoader && (packageInfo?.details?.isStandalone === 0) ? <Box sx={{ marginLeft: 'auto' }}>
                  <Loader />
                </Box> : process.env.REACT_APP_STAGE === 'development' && userData?.is_staff && (packageInfo?.details?.isStandalone === 0) ?
                  <ActionMenu packageInfo={packageInfo} openDialog={openDialog} />
                  : null
              }
            </Box>

            {templatesAvailable.length > 1 && (owners.includes(userData?.user?.email) || userData?.is_staff) && packageInfo?.details?.componentName && !loading ? <Tooltip title="Delete Template"><Paper style={{ display: 'flex' }}><DeleteIcon style={{ cursor: 'pointer', color: '#f05f40', padding: '5px' }} onClick={() => { openDialog('deleteTemplate') }} /></Paper></Tooltip> : ''}

            {
              packageInfo?.details?.componentName && (owners.includes(userData?.user?.email) || userData?.is_staff) && !packageInfo?.details?.publishDate && !loading ? <Tooltip title="Delete Package"><Paper style={{ display: 'flex' }}><DeleteForever style={{ cursor: 'pointer', color: '#f05f40', padding: '5px' }} onClick={() => { openDialog('deletePackage') }} /></Paper></Tooltip>
                : null
            }
          </div>
        </Box>

      </Grid>
      <Grid item xs={12}>
        <PackageInfoCard downloadUrl={downloadUrl} packageInfo={packageInfo} />
      </Grid>
      <Grid item xs={12}>
        <Box sx={carouselDivStyle} style={{ overflowX: 'auto' }}>
          {
            carouselItems && carouselItems.length ? <Box sx={arrowWrapperStyle}> <KeyboardArrowLeft onClick={() => {
              sideScroll(contentWrapper.current, 25, 100, -10);
            }} sx={largeIconStyle} /></Box> : null
          }
          {
            carouselItems && carouselItems.length ?
              <Box sx={carouselWrapperStyle} ref={contentWrapper}>

                {carouselItems.map((item, index) => (
                  index === 0 && videoUrl ?
                    <Card sx={{ marginRight: '20px', flexShrink: 0, borderRadius: '16px', position: 'relative' }} key={index}>
                      <Box sx={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, zIndex: 1, cursor: 'pointer' }} onClick={() => setOpenVideoModal(true)} />
                      <ReactPlayer url={videoUrl} playing={false} height={'240px'} width={'395px'} onError={() => {
                        setVideoUrl(null)
                        setCaraouselItems(carouselItems.filter((item, i) => i !== 0))
                      }} />
                    </Card>
                    :
                    <Box
                      component="img"
                      src={`${downloadUrl}/${item}`}
                      sx={carouselImageStyle}
                      alt='carousel'
                      key={index}
                      onClick={() => {
                        setOpenImageGallery(true)
                      }}
                    />

                ))}
              </Box>
              :
              <Box
                component="img"
                src={videoImagesGoesHere}
                sx={carouselImageStyle}
                alt='carousel'
              />
          }

          {
            carouselItems && carouselItems.length ? <Box sx={arrowWrapperStyle}><KeyboardArrowRight onClick={() => {
              sideScroll(contentWrapper.current, 25, 100, 10);
            }} sx={largeIconStyle} /></Box> : null
          }
        </Box>
        {/* Thumbnails */}
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mt: 2 }}>
          {carouselItems && carouselItems.length ? carouselItems.map((item, index) => (
            ((videoUrl && index !== 0) || (!videoUrl)) && <Card sx={{
              cursor: 'pointer',
              margin: '10px 5px', padding: 0, borderRadius: '8px'
            }}>
              <img
                key={index}
                src={`${downloadUrl}/${item}`}
                alt={`carousel-${index}`}
                style={{
                  width: '80px',
                  height: '48px',
                  objectFit: 'contain',
                }}
                onClick={() => handleItemClick(index)}
              />
            </Card>
          )) : null}
        </Box>
      </Grid>
      <Grid container mt={2} p={2} ml={2}>
        <Grid item lg={12} md={12} sm={12} sx={{
          borderBottom: 1,
          borderColor: theme => theme.palette.divider,
          paddingBottom: '10px', paddingBottom: '10px'
        }}>
          <Typography style={{ color: '#333' }} sx={{ typography: { sm: 'body2', xs: 'subtitle1' } }} >
            {
              packageInfo?.details?.portal_data?.description || readMe ? (

                <ReactMarkdown>{packageInfo?.details?.portal_data?.description || readMe}</ReactMarkdown>
              ) :
                <div>
                  <Skeleton variant="rounded" width={'100%'} height={200} />
                </div>

            }


          </Typography>
        </Grid>

        <Grid item lg={12} md={12} sm={12}>
          {packageInfo?.details?.publishDate ? <PackageDetailsCard permission={updatedPermission} data={location.state} packageInfo={packageInfo} bucketURLS={bucketURLS} /> :
            <Typography style={{ color: '#333' }} sx={{ typography: { sm: 'h6' } }} >
              Publish Details Not Available!
            </Typography>
          }
        </Grid>


      </Grid>
    </Grid>
    {
      deleteSuccess ? <Snackbar open={deleteSuccess} autoHideDuration={2000}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}>
        <Alert severity="success" sx={{ width: '100%' }}  >SuccessFully Deleted! </Alert>
      </Snackbar> : ''
    }

    <CustomSnackBar
      open={openSnackBar}
      handleClose={handleClose}
      error={error}
      message={snackbarMessage}
    />
  </div>)
}
export default PackageInfo;



